module.exports = __webpack_public_path__ + "img/facebook.05d408e6.svg";